import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import CarouselTag from './CarouselTag';
import ExploreButton from './ExploreButton';
import CarouselStyles from './style';

function CarouselContent({ userName, heading, description, tags, buttonText, buttonIcon }) {
    return (
        <Box sx={CarouselStyles.Content.container}>
            <Box sx={{ width: '100%', color: '#fff' }}>
                <Typography component="header" sx={CarouselStyles.Content.header}>
                    Welcome {userName},
                </Typography>
                <Typography component="h1" sx={CarouselStyles.Content.heading}>
                    {heading}
                </Typography>
                <Typography component="p" sx={CarouselStyles.Content.description}>
                    {description}
                </Typography>
            </Box>

            <Box sx={CarouselStyles.Content.tagsContainer}>
                {tags.map((tag, index) => (
                    <CarouselTag key={index} text={tag} />
                ))}
            </Box>

            <ExploreButton text={buttonText} iconUrl={buttonIcon} navigateTo="/reference-implementation-services" />
        </Box>
    );
}

CarouselContent.propTypes = {
    userName: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    tags: PropTypes.any.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonIcon: PropTypes.string.isRequired,
};

export default CarouselContent;
